module.exports = __webpack_public_path__ + "static/media/img1.1fdda770.jpg";